import React from 'react';
import { Link } from 'react-router-dom';
import Seo from '../components/Seo';
import {
  BUSINESS_INFO,
  hasIncompleteLegalBusinessInfo,
  LEGAL_LAST_UPDATED_LABEL,
  LEGAL_TEXT_VERSION
} from '../lib/legal-config';
import { LEGAL_PAGE_SEO } from '../lib/seo';

function LegalWarning() {
  if (!hasIncompleteLegalBusinessInfo()) {
    return null;
  }

  return (
    <p className="legal-warning">
      Attenzione: alcuni dati aziendali obbligatori sono placeholder e vanno completati prima del go-live.
    </p>
  );
}

const TermsSalesPage = () => {
  return (
    <section className="legal-page">
      <Seo title={LEGAL_PAGE_SEO.terms.title} description={LEGAL_PAGE_SEO.terms.description} path="/termini-vendita" />
      <h2 className="shop-title">Termini di Vendita</h2>
      <p className="legal-meta">
        Versione: <strong>{LEGAL_TEXT_VERSION}</strong> | Ultimo aggiornamento: {LEGAL_LAST_UPDATED_LABEL}
      </p>
      <LegalWarning />

      <section className="legal-section">
        <h3>Venditore</h3>
        <p>
          {BUSINESS_INFO.legalName}, {BUSINESS_INFO.address}. P.IVA: {BUSINESS_INFO.vatNumber}. Contatti:{' '}
          {BUSINESS_INFO.email} - {BUSINESS_INFO.phone}.
        </p>
      </section>

      <section className="legal-section">
        <h3>Oggetto</h3>
        <p>
          I presenti termini regolano la vendita online dei prodotti disponibili nello shop del sito{' '}
          {BUSINESS_INFO.brandName}. Il menu pizzeria in homepage e&apos; area informativa separata.
        </p>
      </section>

      <section className="legal-section">
        <h3>Procedura d&apos;acquisto</h3>
        <ol>
          <li>Selezione prodotti e inserimento nel carrello.</li>
          <li>Verifica riepilogo pre-ordine e accettazione dei termini.</li>
          <li>Reindirizzamento a Stripe per il pagamento.</li>
          <li>Conferma ordine dopo esito positivo del pagamento.</li>
        </ol>
      </section>

      <section className="legal-section">
        <h3>Prezzi e pagamenti</h3>
        <p>
          Tutti i prezzi sono espressi in EUR. Le spese di spedizione sono indicate al checkout. I pagamenti sono
          gestiti tramite Stripe.
        </p>
      </section>

      <section className="legal-section">
        <h3>Spedizione, recesso e assistenza post-vendita</h3>
        <p>
          La spedizione avviene in Italia, con affidamento al corriere entro 10 giorni lavorativi dalla conferma del
          pagamento. Il diritto di recesso del consumatore si applica nei casi previsti dalla normativa vigente, con le
          relative eccezioni di legge per specifiche categorie di beni. Per dettagli operativi consulta la pagina{' '}
          <Link to="/spedizioni-resi">Spedizioni e Resi</Link>.
        </p>
      </section>

      <section className="legal-section">
        <h3>Limitazioni geografiche</h3>
        <p>Le spedizioni sono disponibili sul territorio italiano, incluse isole.</p>
      </section>

      <section className="legal-section">
        <h3>Legge applicabile</h3>
        <p>
          Il contratto e&apos; regolato dalla normativa italiana ed europea applicabile al consumatore. Resta fermo il
          foro del consumatore quando previsto dalla legge.
        </p>
      </section>
    </section>
  );
};

export default TermsSalesPage;
